import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  btnPrimary: {
    paddingLeft: 20,
    paddingRight: 20,
    background:
      'transparent linear-gradient(230deg, #FFDC27 0%, #E63C3C 50%, #000A8C 100%) 0% 0% no-repeat padding-box',
    color: '#fff',
    '@media only screen and (max-width: 600px)': {
      width: 'auto',
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  textHeader: {
    display: 'block',
  },
  title: {
    textAlign: 'left',
    color: '#000A8C',
    fontSize: 36,
    fontFamily: 'Poppins',
    lineHeight: '50.4px',
    margin: '0px 0px 15px',
    '@media only screen and (max-width: 600px)': {
      fontSize: 20,
      lineHeight: '26px',
    },
  },
  text: {
    color: '#151528 !important',
    fontSize: '20px',
    fontFamily: 'Poppins !important',
    textAlign: 'center',
    margin: '0px 0px 15px',
    '@media only screen and (max-width: 600px)': {
      width: 'auto',
    },
    '&>p': {
      margin: 0,
    },
    '& a': {
      color: '#151528 !important',
    },
    '& li': {
      textAlign: 'left',
    },
    '& *': {
      color: '#151528 !important',
      fontFamily: 'Poppins !important',
      margin: 0,
    },
  },
  flexCenter: {
    width: '47%',
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    position: 'relative',
    marginBottom: 40,
    marginTop: 70,
    background: 'transparent',
    padding: 40,
    height: '60vh',
    '@media only screen and (max-width: 600px)': {
      width: 'auto',
      padding: 20,
      margin: 0,
      marginTop: 20,
      background: 'transparent',
    },
  },
  buttonGoTo: {
    color: '#000A8C',
    fontSize: 14,
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 16,
    paddingBottom: 16,
    textTransform: 'none',
    borderRadius: 10,
    height: 'auto',
    marginTop: 20,
    fontFamily: 'Poppins',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
  buttonSticky: {
    position: 'sticky',
    bottom: 0,
    padding: 10,
    background: 'white',
    zIndex: 1000,
  },
  bodycenter: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    zIndex: 8,
  },
});
